import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "select2";

const Select2Dropdown = ({ options, onChange, placeholder, caption }) => {
  const selectRef = useRef();

  useEffect(() => {
    const $select = $(selectRef.current);
    $select.select2({
      data: options,
      placeholder,
      allowClear: false,
      width: "100%",
      dropdownParent: $("#filterPopup"),
    });

    $select.on("change", (e) => {
      const selectedValue = e.target.value;
      onChange(selectedValue);
    });

    // Cleanup Select2 on unmount
    return () => {
      $select.select2("destroy");
    };
  }, [options, onChange, placeholder]);

  return (
    <div className="fitmyDevice-brand">
      <label>{caption}</label>
      <select className="js-states form-control" ref={selectRef}>
        <option value="" disabled hidden>
          {placeholder}
        </option>
      </select>
    </div>
  );
};

export default Select2Dropdown;
